import React, { useMemo } from 'react';
import useDetectIsMobile from '../hook/use-detect-is-mobile';

const Pagination = ({
  totalPage,
  currentPage,
  pageNumberLimit,
  onChangeCurrentPage,
  onChangeMaxPageLimit,
  onChangeMinPageLimit,
  maxPageLimit,
  minPageLimit
}) => {
  const { isTablet, isMobile } = useDetectIsMobile();

  const pages = useMemo(() => {
    const _pages = [];
    for (let i = 1; i <= totalPage; i++) {
      _pages.push(i);
    }

    return _pages;
  }, [totalPage]);

  const onNext = () => {
    if (currentPage !== totalPage) {
      const toPage = currentPage + 1;

      if (toPage > maxPageLimit) {
        onChangeMaxPageLimit(maxPageLimit + pageNumberLimit);
        onChangeMinPageLimit(minPageLimit + pageNumberLimit);
      }

      onChangeCurrentPage(toPage);
    }
  };

  const onPrev = () => {
    if (currentPage !== 1) {
      const toPage = currentPage - 1;

      if (toPage % pageNumberLimit === 0) {
        onChangeMaxPageLimit(maxPageLimit - pageNumberLimit);
        onChangeMinPageLimit(minPageLimit - pageNumberLimit);
      }

      onChangeCurrentPage(toPage);
    }
  };

  const onPageNumber = (isActive, toPage) => () => {
    if (!isActive) onChangeCurrentPage(toPage);
  };

  return (
    <nav aria-label="pagination">
      <ul className="flex flex-wrap justify-center -space-x-px text-base gap-3">
        <li>
          <button
            disabled={currentPage === 1}
            onClick={onPrev}
            className="flex items-center justify-center px-4 h-10 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded hover:bg-gray-100 hover:text-gray-700"
          >
            {isTablet || isMobile ? '❮' : 'Sebelumnya'}
          </button>
        </li>
        {minPageLimit >= 1 && (
          <li>
            <button
              className="flex items-center justify-center px-2 h-10 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded"
              disabled={true}
            >
              &hellip;
            </button>
          </li>
        )}
        {pages.map((item, index) => {
          if (item <= maxPageLimit && item > minPageLimit) {
            const isActive = currentPage === index + 1;
            const buttonProps = isActive
              ? {
                  'aria-current': 'page',
                  className:
                    'flex items-center justify-center px-4 h-10 border border-gray-300 bg-primary-800 text-white rounded text-sm font-semibold'
                }
              : {
                  className:
                    'flex items-center justify-center px-4 h-10 leading-tight text-black bg-white border border-gray-300 rounded hover:bg-gray-100 hover:text-gray-700 text-sm font-semibold'
                };
            return (
              <li key={index}>
                <button onClick={onPageNumber(isActive, index + 1)} {...buttonProps}>
                  {index + 1}
                </button>
              </li>
            );
          }
        })}
        {pages.length > maxPageLimit && (
          <li>
            <button
              className="flex items-center justify-center px-2 h-10 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded"
              disabled={true}
            >
              &hellip;
            </button>
          </li>
        )}
        <li>
          <button
            onClick={onNext}
            disabled={currentPage === totalPage}
            className="md:flex items-center justify-center px-4 h-10 leading-tight text-black bg-secondary-500 border border-secondary-500 rounded hover:bg-secondary-800 hover:text-black"
          >
            {isTablet || isMobile ? '❯' : 'Selanjutnya'}
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
